import React from 'react';
import { resolveTheme, panelStyle } from '../themes';
import type { Theme } from '../themes';
import type { TransitionMode } from '../../domain/value-objects/TransitionConfig';

interface TransitionToggleProps {
  theme?: string | Theme;
  mode: TransitionMode;
  onToggle: (mode: TransitionMode) => void;
}

export function TransitionToggle({ theme, mode, onToggle }: TransitionToggleProps) {
  const T = resolveTheme(theme);
  const isChecked = mode === 'crossfade';

  return (
    <button
      role="switch"
      aria-checked={isChecked}
      aria-label="Toggle crossfade transition"
      onClick={() => onToggle(isChecked ? 'instant' : 'crossfade')}
      style={panelStyle(T, {
        padding: '6px 12px', display: 'flex', alignItems: 'center', gap: 8,
        cursor: 'pointer', appearance: 'none', font: `11px ${T.font}`,
      })}
    >
      <div style={{
        width: 28, height: 14, borderRadius: 7, position: 'relative',
        background: isChecked ? T.accent : 'rgba(127,127,127,.3)',
        transition: 'background .2s',
      }}>
        <div style={{
          width: 10, height: 10, borderRadius: '50%', background: '#fff',
          position: 'absolute', top: 2,
          left: isChecked ? 16 : 2,
          transition: 'left .2s',
        }} />
      </div>
      <span style={{ color: T.textDim, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {mode === 'crossfade' ? 'Crossfade' : 'Instant'}
      </span>
    </button>
  );
}
